export default "__VITE_ASSET__Zv9ShSCj__"